import React from "react";
import { Helpers } from "../helpers/helpers";
import { IEpiProps, IReference } from "../models/vertex-search-page-models";
import { useVertexSearchContext } from "../reducers/vertex-search-page-provider";

interface IProps {
    reference: IReference
}

interface IContextProps {
    epiProps: IEpiProps
}

export const SearchAnswerReference = (props: IProps) => {
    const { epiProps }: IContextProps = useVertexSearchContext();
    let showLockIcon = Helpers.showLockIcon(props.reference.url, epiProps.publicationsSearchResultLockIconsUrlsToExclude);
    return (
        <div className="vertex-search-overview-citation-item">
            <div className="vertex-search-overview-citation-item-header">
                <h6 className="vertex-search-overview-citation-item-title">{props.reference.title}</h6>
                {
                    props.reference.publishDate && <p className="vertex-search-result-item-date">{props.reference.publishDate}</p>
                }
            </div>
            <div className='vertex-search-link-container'>
                {
                    showLockIcon &&
                    <div className="search-result-icon">
                        <svg>
                            <use xlinkHref="#lock-locked"></use>
                        </svg>
                    </div>
                }
                <a className='vertex-search-link' href={props.reference.url}>{props.reference.url}</a>
            </div>
        </div>
    )
}